import { render, staticRenderFns } from "./Naclodnoy_.vue?vue&type=template&id=503b5f84&"
import script from "./Naclodnoy_.vue?vue&type=script&lang=js&"
export * from "./Naclodnoy_.vue?vue&type=script&lang=js&"
import style0 from "./Naclodnoy_.vue?vue&type=style&index=0&id=503b5f84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports